<template>
    <div class="popup popup-cart popup__sizes" :class="{ 'popup-show': show }">
        <div class="popup__wrapper">
            <div class="popup__content">
                <div class="cart">
                    <div class="cart__top-wrapper">
                        <div class="cart__top top-cart">
                            <div class="top-cart__title">Швидке замовлення</div>
                            <button type="button" class="popup__close _icon-close" @click="closePopup"></button>
                        </div>
                        <div class="payment-options">
                            <MonoCheckoutButtonComponent payment-method="card" button-text="Повна оплата карткою" @payment-sent="handlePaymentSuccess" @payment-error="handlePaymentError" @payment-method-change="handlePaymentMethodChange" />
                        </div>
                        <p v-if="paymentMethod === 'cash'" class="payment-info">Обираючи оплату при отриманні, ви сплатите лише 150 грн за доставку у якості передоплати</p>
                        <div class="promo-code">
                            <PromocodeComponent />
                        </div>
                        <div class="price-section">
                            <div class="total">
                                <span>Разом</span>
                                <span>{{ totalPriceCart.toFixed(2) }} грн.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useCartStore } from "@/stores/cart";
import { usePromoCodeStore } from "@/stores/promoCode";
import MonoCheckoutButtonComponent from "./MonoCheckoutButtonComponent.vue";

const storeCart = useCartStore();
const promoStore = usePromoCodeStore();
const { $getCookie } = useNuxtApp();

const props = defineProps({
    show: {
        type: Boolean,
        required: true,
    },
});

const cart = ref([]);
const freeDeliveryThreshold = 3000;
const totalPriceCart = computed(() => storeCart.totalPriceCart);

const emit = defineEmits(["update:show"]);

const paymentMethod = ref("card");

// Методы
const closePopup = () => {
    emit("update:show", false);
};

const handlePaymentSuccess = (result) => {
    console.log("Платеж успешно обработан:", result);
};

const handlePaymentError = (error) => {
    console.error("Ошибка при обработке платежа:", error);
};

const handlePaymentMethodChange = (method) => {
    paymentMethod.value = method;
};

const applyPromoCode = () => {
    console.log(`Промокод "${promoCode.value}" применен`);
};
</script>

<style lang="scss" scoped>
.popup__sizes {
    display: flex;
    justify-content: center;
    align-items: center;
}

.payment-options {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 20px;
}

.payment-info {
    font-size: 14px;
    color: #666;
    margin-bottom: 20px;
}

.price-section {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #ddd;
}

.delivery-info {
    font-size: 14px;
    color: #ff0000;
    margin-top: 10px;
}

.total {
    display: flex;
    justify-content: space-between;
    font-size: 18px;
    font-weight: bold;
}

/* Анимация блеска на кнопке */
.shine-effect {
    position: relative;
    overflow: hidden;
    color: #fff;

    text-align: center;
    cursor: pointer;
    transition: background-color 0.3s, color 0.3s;
}

.shine-effect::before {
    content: "";
    position: absolute;
    top: -100%;
    left: -100%;
    width: 200%;
    height: 200%;
    background: linear-gradient(45deg, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0));
    transform: rotate(45deg);
    animation: shine 2s infinite;
}

@keyframes shine {
    0% {
        transform: translate(-100%, -100%) rotate(45deg);
    }
    100% {
        transform: translate(100%, 100%) rotate(45deg);
    }
}
</style>
